<div class="itens">
  <mat-radio-group
    aria-labelledby="example-radio-group-label"
    class="example-radio-group"
    [(ngModel)]="filter().branchOrUser"
    (ngModelChange)="onSelectBranchOrUser($event)"
  >
    <mat-radio-button class="example-radio-button" [value]="0"
      >CR / Unidade de pesquisa</mat-radio-button
    >

    @if(['0ce77a2a-70a4-477d-9720-aada64089436',
    '92ad6343-de3c-4fe0-8e54-87afbf405d9b',
    'd044e35e-fb49-4198-b3b8-89c7c3b7453f'].includes(userRoleId ?? '')){
    <mat-radio-button class="example-radio-button" [value]="1"
      >Perfil de usuario</mat-radio-button
    >
    }
  </mat-radio-group>

  @if(filter().branchOrUser === 1){
  <div class="select">
    <mat-form-field appearance="outline">
      <mat-label>Perfil</mat-label>
      <mat-select
        [(ngModel)]="filter().profileId"
        (ngModelChange)="onSelectProfile($event)"
      >
        @if(userRoleId === '0ce77a2a-70a4-477d-9720-aada64089436'){
        <mat-option
          [value]="1"
          (onSelectionChange)="selectprofileName('Supervisor')"
          >Supervisor</mat-option
        >
        <mat-option
          [value]="0"
          (onSelectionChange)="selectprofileName('Gerente de unidade')"
          >Gerente de unidade</mat-option
        >
        <mat-option
          [value]="2"
          (onSelectionChange)="selectprofileName('Gerente regional')"
          >Gerente regional</mat-option
        >
        } @else if (userRoleId === '92ad6343-de3c-4fe0-8e54-87afbf405d9b') {
        <mat-option
          [value]="1"
          (onSelectionChange)="selectprofileName('Supervisor')"
          >Supervisor</mat-option
        >
        <mat-option
          [value]="0"
          (onSelectionChange)="selectprofileName('Gerente de unidade')"
          >Gerente de unidade</mat-option
        >
        }@else if (userRoleId === 'd044e35e-fb49-4198-b3b8-89c7c3b7453f') {
        <mat-option
          [value]="0"
          (onSelectionChange)="selectprofileName('Gerente de unidade')"
          >Gerente de unidade</mat-option
        >
        }
      </mat-select>
    </mat-form-field>
  </div>
  }
</div>

@if (filter().branchOrUser === 0){
<div class="user-units">
  <div class="all-units">
    <p>Unidades não consideradas nos resultados:</p>
    <div class="input-icon">
      <input
        type="text"
        class="form-control"
        placeholder="Buscar"
        [formControl]="filterUnits"
      />
      <img src="assets/svg/search.svg" alt="search" />
    </div>

    <div class="units">
      @for (unit of units; track $index) {
      <p
        [ngClass]="{ active: moveToSelected.includes(unit.id) }"
        (click)="onMoveToSelected(unit.id)"
      >
        CR{{ unit.code + " - " + unit.name }}
      </p>
      }
    </div>
  </div>
  <div class="actions">
    <div
      [ngClass]="{
        disabled: !units.length
      }"
      (click)="selectAll()"
    >
      >>
    </div>
    <div
      [ngClass]="{
        disabled: !moveToSelected.length
      }"
      (click)="onSelected()"
    >
      >
    </div>
    <div
      [ngClass]="{
        disabled: !moveToUnselected.length
      }"
      (click)="onUnselected()"
    >
      <
    </div>
    <div
      [ngClass]="{
        disabled: !selectedUnits.length
      }"
      (click)="unselectedAll()"
    >
      <<
    </div>
  </div>
  <div class="selected-units">
    <p>Unidades consideradas nos resultados:</p>
    <div class="input-icon">
      <input
        type="text"
        class="form-control"
        placeholder="Buscar"
        [formControl]="filterSelectedUnits"
      />
      <img src="assets/svg/search.svg" alt="search" />
    </div>

    <div class="units">
      @for (unit of selectedUnits; track $index) {
      <p
        [ngClass]="{
          active: moveToUnselected.includes(unit.id),
          disabled: !moveToUnselected.length
        }"
        (click)="onMoveToUnselected(unit.id)"
      >
        CR{{ unit.code + " - " + unit.name }}
      </p>
      }
    </div>
  </div>
</div>
} @else if (filter().branchOrUser === 1 && users().length) {
<div class="users">
  <mat-radio-group aria-label="Select an User" [(ngModel)]="filter().userId">
    @for (user of users(); track $index) {
    <mat-radio-button [value]="user.id" (click)="selectUserName(user.name)">{{
      user.name
    }}</mat-radio-button>
    }
  </mat-radio-group>
</div>
}
